import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./navbar.css";
import TestImage from '../../assets/TestImage.jpg';

const Navbar = () => {
  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole") || ""; // ✅ Fix: Define userRole

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userRole"); // ✅ Ensure role is removed
    navigate("/login");
  };

  return (
    <div className="navbarWrapper">
      <nav className="navbar">
        <img src={TestImage} alt="Logo" className="TestImage" />

        <div className="desktopMenu">
          <Link to="/" className="desktopMenuListItem">Home</Link>
        
          <Link to="/whatIsRugby" className="desktopMenuListItem">What Is Rugby</Link>
          <Link to="/contact" className="desktopMenuListItem">How You Can Help</Link>
        </div>

        {userRole === "admin" && (
          <Link to="/create-post" className="createPostButton">Create Post</Link>
        )}
        {userRole === "admin" && (
  <Link to="/admin" className="desktopMenuListItem">Admin Panel</Link>
)}

        <div className="authButtons">
          {localStorage.getItem("token") ? (
            <button onClick={handleLogout} className="authButton">Logout</button>
          ) : (
            <>
              <Link to="/login" className="authButton">Login</Link>
              <Link to="/signup" className="authButton">Sign Up</Link>
            </>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
